import { LOGIN_START,LOGIN_STATUS,SET_STRUCTURE,LOGOUT_START } from "../types";

export const login = (payload) => ({
    type: LOGIN_START,
    payload
})

export const logout = () => ({
    type: LOGOUT_START
})

export const login_status =()=>({
    type: LOGIN_STATUS
})

export const setStrecuture = (payload) => ({
    type: SET_STRUCTURE,
    payload
})